import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useVesselOperationType, type VesselOperationType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<VesselOperationType>
    useData={useVesselOperationType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
